import type { Numeric } from '@ps-smart-cp/ppfw-client';

function calcIntegerLength(min: number, max: number) {
  return Math.max(min.toString().length, max.toString().length);
}

function calcDecimalPlacesLength(decimalPlaces: number) {
  return decimalPlaces === 0 ? 0 : decimalPlaces + 1;
}

function calcCommaNumbers(min: number, max: number) {
  return Math.max(
    min.toLocaleString().replaceAll(/[^,]/g, '').length,
    max.toLocaleString().replaceAll(/[^,]/g, '').length,
  );
}

function calcAmountColumnWidth(attribute: Numeric) {
  const { min, max, decimalPlaces } = attribute;
  return (
    (calcIntegerLength(min, max) + calcDecimalPlacesLength(decimalPlaces) + calcCommaNumbers(min, max)) * 9
  );
}

export { calcAmountColumnWidth };
